import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Selected",
  "use": "icon-Selected-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Selected\">\r\n<path d=\"M3 7.5L7 11.5L13 5.5\" stroke=\"#222222\" stroke-width=\"1.5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol